import DestinationSearch from './components/DestinationSearch'

import './App.css'

const App = () => <DestinationSearch />

export default App
